import { ChipsideComponent } from "../chipside-component";

export class Badge extends ChipsideComponent {
	constructor() {
		super();

		this.variation = this.getAttribute("variation") ?? "theme";
		this.size = this.getAttribute("size");
		this.icon = this.getAttribute("icon");
		this.badgeStyle = this.getAttribute("badge-style");
	}

	parsedCallback() {
		this.classList.add("badge", `badge--${this.variation}`);

		if (this.size) { this.classList.add(`badge--${this.size.toLowerCase()}`); }
		if (this.icon) { this.prepend(document.createElementWithContents("i", null, { className: this.icon })); }
	}
}